import { axios } from '@/utils/request';

export const getLogo = (params) =>
  axios({
    url: '/website/tLogo/homeList',
    method: 'get',
    params,
  });

export const getNav = (params) =>
  axios({
    url: '/website/tColumn/all',
    method: 'get',
    params,
  });

export const getList = (params) =>
  axios({
    url: '/website/tContent/listIndex',
    method: 'get',
    params,
  });

export const getDetail = (params) =>
  axios({
    url: '/website/tContent/queryById',
    method: 'get',
    params,
  });
